const makeHeading4 = ({text} = {}) => ({
  type: 'heading4',
  children: [
    {
      text: text || '',
    },
  ],
});

export default makeHeading4;
